<script setup>
import { onBeforeMount } from 'vue'
import { useMainStore } from '../stores/main-store'
import FilterInput from './FilterInput.vue'

const mainStore = useMainStore()

const props = defineProps({
  name: {
    type: String,
    default: '',
  },
  attribute: {
    type: Object,
    default: () => {},
  },
})

onBeforeMount(() => {
  const main = mainStore[props.name]

  if (!main[props.attribute.slug]) {
    main[props.attribute.slug] = {}
  }
})
</script>

<template>
  <div class="attribute-list">
    <h3 class="attribute-list__title">{{ attribute.title }}</h3>
    <ul>
      <li v-for="term in attribute.terms" :key="term.slug">
        <FilterInput :term="term" :name="name" :attribute="attribute" />
      </li>
    </ul>
  </div>
</template>

<style lang="scss">
@import '../scss/attribute-list';
</style>
